const QUERY_KEYS = {
  ATHLETE_DETAILS: "ATHLETE_DETAILS",
  ATHLETE_STATS: "ATHLETE_STATS",
  ATHLETE_HIGHLIGHTS: "ATHLETE_HIGHLIGHTS",
  ATHLETE_POSTS: "ATHLETE_POSTS",

  TEAM_DETAILS: "TEAM_DETAILS",
  TEAM_HIGHLIGHTS: "TEAM_HIGHLIGHTS",
  TEAM_POSTS: "TEAM_POSTS",

  CHALLENGE_DETAILS: "CHALLENGE_DETAILS",
  CHALLENGE_SUBSCRIBER_ATHLETE_LIST: "CHALLENGE_SUBSCRIBER_ATHLETE_LIST",

  EVENT_DETAILS: "EVENT_DETAILS",
  EVENT_JOINED_TEAMS: "EVENT_JOINED_TEAMS",

  PRIMARY_SPORT_DETAILS: "PRIMARY_SPORT_DETAILS",
  EARLY_ACCESS_ADD_USER: "EARLY_ACCESS_ADD_USER",
  EARLY_ACCESS_VERIFY_OTP: "EARLY_ACCESS_VERIFY_OTP",
  EARLY_ACCESS_RESEND_OTP: "EARLY_ACCESS_RESEND_OTP",

  GET_IP: "GET_IP",

  ATHLETE_POST_BY_ID: "ATHLETE_POST_BY_ID",
  ATHLETE_HIGHLIGHT_BY_ID: "ATHLETE_HIGHLIGHT_BY_ID",
};

export default QUERY_KEYS;
